<template>
  <div style="padding: 20px;overflow: auto" v-loading="isLoading">
    <div class="house_header">
      <ul>
        <template v-if="isSspUser">
          <li><p>今日收入</p><p>{{numData.income || ''}}</p></li>
          <li><p>昨日收入</p><p>{{numData.yesIncome || ''}}</p></li>
          <li><p>7日均值收入</p><p>{{numData.sevenAvgIncome || ''}}</p></li>
          <li><p>今日CPM</p><p>{{numData.cpm || ''}}</p></li>
          <li><p>昨日CPM</p><p>{{numData.yesCpm || ''}}</p></li>
          <li><p>7日均值CPM</p><p>{{numData.sevenAvgCpm || ''}}</p></li>
          <li><p>今日CPC</p><p>{{numData.cpc || ''}}</p></li>
          <li><p>昨日CPC</p><p>{{numData.yesCpc || ''}}</p></li>
          <li><p>7日均值CPC</p><p>{{numData.sevenAvgCpc || ''}}</p></li>
        </template>
        <template v-else>
          <li><p>本月累计消耗</p><p>{{numData.simulateBidAll || ''}}</p></li>
          <li><p>账号余额</p><p>{{numData.balance || ''}}</p></li>
          <li><p>启用计划 / 总量</p><p>{{`${numData.planNum || ''} / ${numData.planNumAll || ''}`}}</p></li>
          <li><p>启用单元 / 总量</p><p>{{`${numData.unitNum || ''} / ${numData.unitNumAll || ''}`}}</p></li>
          <li><p>启用创意 / 总量</p><p>{{`${numData.ideaNum || ''} / ${numData.ideaNumAll || ''}`}}</p></li>
        </template>
      </ul>
    </div>
    <div class="house_chart">
      <el-date-picker v-model="time" size="small" value-format="yyyyMMdd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="expireTimeOption" :clearable="false" @change="getChart"></el-date-picker>
      <div id="myChart" :style="{width: '100%', height: '400px'}"></div>
      <ul>
        <li v-for="(item, index) of lineData" :key="index" :class="[lineIndex.indexOf(item.id) > -1 ? lineIndex.indexOf(item.id) === 0 ? 'c5EB432' : 'c118DEE' : '']" @click="setLine(item)">{{item.name}}</li>
      </ul>
    </div>
    <div v-if="isSspUser">
      <el-radio-group v-model="top" size="small" @change="getTop">
        <el-radio-button :label="1">广告主消费</el-radio-button>
        <el-radio-button :label="2">站点/APP消费</el-radio-button>
        <el-radio-button :label="3">代码位消费</el-radio-button>
      </el-radio-group>
      <ul style="margin-top: 10px;">
        <li>
          <p style="margin: 20px 0 10px;padding-left: 10px;color: #333;font-size: 16px;border-left: 4px solid #108CEE;line-height: 1">昨日消费Top10</p>
          <el-table :data="topData" size="small" style="width: 402px;border: 1px solid #ccc">
            <el-table-column prop="order" label="排名" width="50" key="1"></el-table-column>
            <el-table-column v-if="top === 1" prop="advertiserName" label="广告主" width="200" key="2"></el-table-column>
            <el-table-column v-else-if="top === 2" prop="appSiteId" label="APP/站点" width="200" key="3"></el-table-column>
            <el-table-column v-else-if="top === 3" prop="slotId" label="代码位ID" width="200" key="4"></el-table-column>
            <el-table-column prop="consume" label="消费" width="150" key="5"></el-table-column>
          </el-table>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      isSspUser: !!this.$store.state.user.info.isSspUser,
      isLoading: false,
      time: [this.myOption.getDate(6), this.myOption.getDate(0)],
      numData: {},
      chartData: {},
      lineData: {},
      lineIndex: {},
      apiModule: null,
      top: 1,
      topData: [],
      expireTimeOption: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    if (this.isSspUser) {
      this.lineData = [
        {id: 'income', name: '收入'},
        {id: 'reqNum', name: '请求量'},
        {id: 'showNum', name: '展现量'},
        {id: 'clickNum', name: '点击量'},
        {id: 'clickRatio', name: '点击率(%)'},
        {id: 'cpm', name: 'CPM'},
        {id: 'cpc', name: 'CPC'},
        {id: 'activateNum', name: '转化量'}
      ]
      this.lineIndex = ['income', 'reqNum']
      this.apiModule = this.myOption.houseModule.in
      this.getTop()
    } else {
      this.lineData = [
        {id: 'showNum', name: '展示量'},
        {id: 'clickNum', name: '点击量'},
        {id: 'simulateBid', name: '消费量'},
        {id: 'ctr', name: 'CTR'},
        {id: 'cpm', name: 'CPM'},
        {id: 'cpc', name: 'CPC'},
        {id: 'activateNum', name: '转化量'}
      ]
      this.lineIndex = ['showNum', 'clickNum']
      this.apiModule = this.myOption.houseModule.out
    }
    this.getNumber()
    this.getChart()
  },
  methods: {
    // 获取TOP10
    getTop () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.apiModule.id
        },
        url: this.myOption.requestUrl + this.apiModule.top,
        data: this.qs.stringify({
          topType: this.top
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.topData = res.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取总量
    getNumber () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.apiModule.id
        },
        url: this.myOption.requestUrl + this.apiModule.number,
        data: {}
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.numData = res.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取趋势图
    getChart () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.apiModule.id
        },
        url: this.myOption.requestUrl + this.apiModule.chart,
        data: this.qs.stringify({
          startDay: this.time[0],
          endDay: this.time[1]
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.chartData = res.data.data
          this.drawLine()
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 渲染趋势图
    drawLine () {
      this.isLoading = true
      // 根据趋势图类型选项处理数据
      let xData = []
      let xState = true
      let yData = []
      let color = ['#5EB432', '#118DEE']
      for (let key in this.lineIndex) {
        let lineData = []
        for (let val2 of this.chartData) {
          if (xState) {
            xData.push(val2.createDay)
          }
          lineData.push(val2[this.lineIndex[key]])
        }
        xState = false
        yData.push({
          name: this.myOption.getIdData(this.lineData, this.lineIndex[key], 'name'),
          data: lineData,
          type: 'line',
          symbol: 'circle',
          symbolSize: 6,
          showSymbol: true,
          smooth: true,
          itemStyle: {
            color: color[key],
            borderColor: '#fff',
            borderWidth: 1,
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 6
          },
          lineStyle: {
            color: color[key]
          }
        })
      }
      // 基于准备好的dom，初始化echarts实例
      if (!this.doc_chart) {
        this.doc_chart = this.$echarts.init(document.getElementById('myChart'))
      }
      // 绘制图表
      this.doc_chart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,.9)',
          borderColor: '#333',
          borderWidth: 1,
          padding: [10, 20],
          textStyle: {
            color: '#000',
            fontSize: 12
          },
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
              backgroundColor: '#447ed9',
              margin: 5
            },
            shadowStyle: {
              color: 'rgba(33,155,237,.1)'
            }
          }
        },
        grid: {
          bottom: '12%'
        },
        legend: {
          show: false,
          data: '',
          bottom: 0
        },
        xAxis: {
          data: xData,
          type: 'category',
          lineWidth: 0,
          boundaryGap: true,
          silent: true,
          axisLine: {
            lineStyle: {
              color: '#888'
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: '#333'
          }
        },
        yAxis: {
          axisLine: {
            show: true
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          type: 'value',
          splitNumber: 5,
          minInterval: 1
        },
        series: yData
      }, true)
      this.isLoading = false
    },
    setLine (data) {
      if (this.lineIndex.indexOf(data.id) > -1) {
        return false
      }
      this.lineIndex.splice(0, 1)
      this.lineIndex.push(data.id)
      this.drawLine()
    }
  }
}
</script>

<style scoped>
  .house_header{
    margin-bottom: 20px;
    padding: 20px;
    width: 100%;
    border: 1px solid #ccc;
    height: 150px;
  }
  .house_header>ul{
    display: flex;
    justify-content: space-between;
    height: 100%;
  }
  .house_header>ul>li{
    margin-left: 20px;
    padding: 20px 20px 20px 0;
    width: 20%;
    height: 100%;
    border-right: 1px solid #ccc;
  }
  .house_header>ul>li>p:first-child{
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .house_header>ul>li>p:last-child{
    color: #666;
    font-size: 18px;
  }
  .house_header>ul>li:first-child{
    margin-left: 0;
  }
  .house_header>ul>li:last-child{
    border-right: 0;
  }

  .house_chart{
    margin-bottom: 20px;
    width: 100%;
    border: 1px solid #ccc;
    padding: 20px
  }
  .house_chart>ul{
    display: flex;
    justify-content: center;
  }
  .house_chart>ul>li{
    position: relative;
    margin: 0 30px;
    font-size: 16px;
    cursor: pointer;
  }
  .house_chart>ul>li:before{
    content: ' ';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-120%, -50%);
    width: 10px;
    height: 2px;
  }
  .house_chart>ul>li:after{
    content: ' ';
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(120%, -50%);
    width: 10px;
    height: 2px;
  }

  .c118DEE{
    color: #118DEE;
  }
  .c118DEE:before, .c118DEE:after{
    background-color: #118DEE;
  }
  .c5EB432{
    color: #5EB432;
  }
  .c5EB432:before, .c5EB432:after{
    background-color: #5EB432;
  }
</style>



// WEBPACK FOOTER //
// src/components/house/List.vue